import React, { useEffect, useState } from 'react';
import { Box, Fab, Tooltip, Typography } from '@mui/material';
import ChatIconImg from '../assets/socialLinks.png';
import MessengerIcon from '../assets/social/messenger.png';
import FacebookIcon from '../assets/social/fb.png';
import InstagramIcon from '../assets/social/instagram.png';
import LineIcon from '../assets/social/line.png';
import TelegramIcon from '../assets/social/telegram.png';
import TwitterIcon from '../assets/social/twitter.png';
import ViberIcon from '../assets/social/viber.png';
import WeChatIcon from '../assets/social/wechat.png';
import WhatsAppIcon from '../assets/social/wa.png';
import YouTubeIcon from '../assets/social/yt.png';
import PinterestIcon from '../assets/social/pinterest.png';
import { getSocialLinks } from '../utils/socialLinks';
import { useDispatch, useSelector } from '../redux/store';

const FloatingChatButton = () => {
  const { siteSettings } = useSelector((x) => x.lookup);
  const [open, setOpen] = useState(false);
  const [chatLinks, setChatLinks] = useState([]);
  const FloatingChatItem = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    px: 2,
    py: 1.2,
    cursor: 'pointer',
    borderRadius: 1,
    border: '1px solid #f5b007',
    background: 'linear-gradient(180deg, #FFC933 0%, #F5B400 100%)',
    boxShadow: '0px 2px 6px 0px #000000B2',
    transition: 'all 0.25s ease',
    '&:hover': {
      transform: 'translateX(-4px)',
      boxShadow: '0px 4px 12px rgba(0,0,0,0.35)',
    },
  };

  useEffect(() => {
    const links = getSocialLinks(siteSettings).filter((item) => item.url !== '' && item.url !== undefined);
    setChatLinks(links);
  }, [siteSettings]);

  if (!chatLinks.length) return null;

  return (
    <>
      {open && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 140,
            right: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            zIndex: 1300,
          }}
        >
          {chatLinks.map((item) => (
            <Tooltip key={item.id} title={item.name} placement="left">
              <Box onClick={() => window.open(item.url, '_blank')} sx={FloatingChatItem}>
                <img src={item.icon} alt={item.name} width={22} height={22} style={{ objectFit: 'contain' }} />

                <Typography
                  sx={{
                    color: 'white',
                    fontSize: { xs: 14, sm: 15 },
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.name}
                </Typography>
              </Box>
            </Tooltip>
          ))}
        </Box>
      )}

      <Fab
        sx={{
          position: 'fixed',
          bottom: 80,
          right: 16,
          zIndex: 1400,
          background: 'linear-gradient(180deg, #FFC933 0%, #F5B400 100%)',
          border: '1px solid #f5b007',
          boxShadow: '0px 2px 6px 0px #000000B2',
          '&:hover': {
            background: 'linear-gradient(180deg, #FFD24D 0%, #F5A700 100%)',
          },
        }}
        onClick={() => setOpen((prev) => !prev)}
      >
        <img src={ChatIconImg} width={24} height={24} alt="Chat button" />
      </Fab>
    </>
  );
};

export default FloatingChatButton;
